import {
  DEFAULT_ARRIVAL_DATE_FILTER,
  DEFAULT_LOG_DATE_FILTER,
  getRangeFromDateFilter,
} from 'utils/dateUtils'

import {
  COMPANY_FILTER_CHANGE,
  FETCH_SELECTED_COMPANY_DATA_ASYNC,
} from 'containers/PartnerOptions/constants'

import { mockData } from 'components/lib/table/mocks'

import {
  allowListErrorMessage,
  CHECKBOX_TOGGLE,
  CLOSE_ALLOW_LIST_MODAL,
  CREATE_INCIDENT,
  CREATE_PRESET_ASYNC,
  createIncidentErrorCodes,
  FETCH_DIRECTORY_TAGS,
  FETCH_FILTERS,
  FETCH_LOGS_ENTIRE_COUNT,
  FETCH_MITIGATION_DATA_ASYNC,
  FETCH_PRESETS_ASYNC,
  FETCH_THREAT_LOG_DATA,
  INCIDENT_BEING_CREATED,
  isMocked,
  PAGINATE_CHANGE,
  RELEASE_FROM_INVESTIGATION_ASYNC,
  RELEASE_FROM_MS_QUARANTINE_ASYNC,
  RELEASE_FROM_SPAM_ASYNC,
  RESET_ALL_FILTERS,
  RESET_ARRIVAL_END_DATE,
  RESET_LOG_END_DATE,
  SELECT_ALL,
  SELECT_ALL_RESULTS_TOGGLE,
  SELECT_SAVED_FILTER,
  SET_ALL_FILTERS,
  SET_ARRIVAL_DATE_FILTER,
  SET_FILTER,
  SET_LOADER,
  SET_LOG_DATE_FILTER,
  SET_TAGS_PAGE,
  SET_TAGS_SEARCH,
  SET_UNCHANGEABLE,
  UNSELECT_ALL,
} from './constants'
import { mergeFilters } from './presetsUtils'
import {
  determineSelectedFilter,
  getKeyForReleaseFetching,
  getReleasableDataFromLog,
  isFiltersEqual,
} from './utils'

const logsEntireCountDefaultValue = {
  value: 0,
  loader: false,
  error: null,
}

const mitigationDataDefaultValue = {
  data: {},
  loader: false,
  error: null,
  emailNotFoundErr: false,
}

const trueOrFalseFilters = new Set([
  'silent_mode',
  'is_scanback_report',
  'has_incident',
  'spam_email_released',
])

const INITIAL_PAGE = 1
const tagsInitialState = { tags: {}, tagsLoader: false, totalPages: 0, tagsPage: 1 }
const initialState = {
  data: [],
  total: 0,
  greaterThenMaxTotal: false,
  logsEntireCount: {
    ...logsEntireCountDefaultValue,
  },
  fetchingLogs: false,
  loader: false,
  filtersLoader: false,
  error: null,
  filters: {},
  logDateFilter: DEFAULT_LOG_DATE_FILTER,
  emailDateFilter: DEFAULT_ARRIVAL_DATE_FILTER,
  pageSize: 50,
  selectedFilters: {},
  page: INITIAL_PAGE,
  permissionsError: false,
  mappings: {
    impersonation_sensors: [],
  },
  presets: {},
  defaultFilters: {},
  selectedPresets: {},
  mappingsError: false,
  mitigation: {
    ...mitigationDataDefaultValue,
  },
  fetching: {},
  isPresetsLoading: false,
  failedEmail: null,
  selectedLogsMap: {},
  selectAllStatus: false,
  excludedLogsMap: {},
  ...tagsInitialState,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case RELEASE_FROM_SPAM_ASYNC.INITIATE:
      return { ...state, loader: true }
    case RELEASE_FROM_SPAM_ASYNC.SUCCESS:
    case RELEASE_FROM_SPAM_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        selectedLogsMap: {},
        excludedLogsMap: {},
        selectAllStatus: false,
      }
    case CHECKBOX_TOGGLE: {
      const { id } = action.payload
      const selectedLog = state.data.find((log) => log.id === id)
      const releasedData = getReleasableDataFromLog(selectedLog)

      if (state.selectAllStatus) {
        const newExcludedItems = {
          ...state.excludedLogsMap,
          [id]: state.excludedLogsMap[id] ? false : releasedData,
        }

        return {
          ...state,
          selectedLogsMap: {
            ...state.selectedLogsMap,
            [id]: false,
          },
          excludedLogsMap: {
            ...state.excludedLogsMap,
            [id]: state.excludedLogsMap[id] ? false : releasedData,
          },
          selectAllStatus:
            state.total !==
            Object.keys(newExcludedItems).filter((key) => newExcludedItems[key]).length,
        }
      }

      return {
        ...state,
        selectedLogsMap: {
          ...state.selectedLogsMap,
          [id]: state.selectedLogsMap[id] ? false : releasedData,
        },
        excludedLogsMap: {
          ...state.excludedLogsMap,
        },
      }
    }
    case SELECT_ALL: {
      return {
        ...state,
        selectedLogsMap: {
          ...state.selectedLogsMap,
          ...state.data.reduce(
            (prev, curr) => ({
              ...prev,
              [curr.id]: getReleasableDataFromLog(curr),
            }),
            {}
          ),
        },
        excludedLogsMap: {
          ...state.excludedLogsMap,
          ...state.data.reduce((prev, curr) => ({ ...prev, [curr.id]: false }), {}),
        },
      }
    }
    case UNSELECT_ALL: {
      const newExcludedItems = state.selectAllStatus
        ? {
            ...state.excludedLogsMap,
            ...state.data.reduce((prev, curr) => ({ ...prev, [curr.id]: true }), {}),
          }
        : { ...state.excludedLogsMap }

      return {
        ...state,
        selectAllStatus:
          state.selectAllStatus &&
          state.total !==
            Object.keys(newExcludedItems).filter((key) => newExcludedItems[key]).length,
        selectedLogsMap: {
          ...state.selectedLogsMap,
          ...state.data.reduce((prev, curr) => ({ ...prev, [curr.id]: false }), {}),
        },
        excludedLogsMap: newExcludedItems,
      }
    }
    case SELECT_ALL_RESULTS_TOGGLE:
      return {
        ...state,
        selectAllStatus: !state.selectAllStatus,
        selectedLogsMap: {},
        excludedLogsMap: {},
      }
    case FETCH_FILTERS.INITIATE:
      return {
        ...state,
        filtersLoader: true,
        loader: true,
        mappingsError: false,
      }
    case FETCH_FILTERS.SUCCESS: {
      const presets = action.payload.presets || {}
      return {
        ...state,
        filtersLoader: false,
        filters: action.payload.filters || {},
        mappings: action.payload.mappings || {},
        presets,
      }
    }
    case COMPANY_FILTER_CHANGE: {
      return {
        ...state,
        data: [],
        total: 0,
        greaterThenMaxTotal: false,
        loader: true,
        error: null,
        permissionsError: false,
        selectedLogsMap: {},
        selectAllStatus: false,
      }
    }
    case FETCH_THREAT_LOG_DATA.INITIATE: {
      return {
        ...state,
        data: [],
        total: 0,
        greaterThenMaxTotal: false,
        loader: true,
        fetchingLogs: true,
        error: null,
        permissionsError: false,
        selectedLogsMap: {},
        selectAllStatus: false,
      }
    }
    case FETCH_THREAT_LOG_DATA.SUCCESS: {
      return {
        ...state,
        data: isMocked ? mockData : action.payload.data,
        total: isMocked ? mockData.length : action.payload.total,
        greaterThenMaxTotal: action.payload.greaterThenMaxTotal,
        fetchingLogs: false,
        loader: false,
        error: null,
        permissionsError: false,
      }
    }
    case FETCH_THREAT_LOG_DATA.ERROR: {
      if (action.payload.status === 403) {
        return {
          ...state,
          loader: false,
          permissionsError: true,
          fetchingLogs: false,
        }
      }
      return {
        ...state,
        loader: false,
        error: action.payload,
        fetchingLogs: false,
      }
    }
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS: {
      return {
        ...state,
        ...tagsInitialState,
      }
    }
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.ERROR:
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.CANCEL:
    case FETCH_FILTERS.ERROR:
    case FETCH_THREAT_LOG_DATA.CANCEL: {
      return {
        ...state,
        loader: false,
        filtersLoader: false,
        error: null,
        mappingsError: true,
        fetchingLogs: false,
      }
    }
    case RESET_LOG_END_DATE: {
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
      }
    }
    case RESET_ARRIVAL_END_DATE: {
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
      }
    }
    case SET_FILTER: {
      let setToSelectedFilter = { ...state.selectedFilters }
      const { value, add, preventApiCall } = action.payload

      if (!value || (Array.isArray(value) && !value.length)) {
        delete setToSelectedFilter[action.payload.filter]
      } else if (add) {
        setToSelectedFilter = mergeFilters(setToSelectedFilter, {
          [action.payload.filter]: value,
        })
      } else {
        setToSelectedFilter[action.payload.filter] = value
      }

      return {
        ...state,
        selectAllStatus: false,
        excludedLogsMap: {},
        selectedLogsMap: {},
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
        selectedFilters: setToSelectedFilter,
        page: INITIAL_PAGE,
        loader: !preventApiCall,
        error: null,
      }
    }
    case SET_LOG_DATE_FILTER: {
      const { date } = action.payload
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
        logDateFilter: date,
        logDateRange: getRangeFromDateFilter(date),
        page: INITIAL_PAGE,
        loader: true,
        error: null,
      }
    }
    case SET_ARRIVAL_DATE_FILTER: {
      const { date } = action.payload
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
        selectAllStatus: false,
        excludedLogsMap: {},
        emailDateFilter: date,
        emailDateRange: Array.isArray(date) ? date : getRangeFromDateFilter(date),
        page: INITIAL_PAGE,
        loader: true,
        error: null,
      }
    }
    case SET_ALL_FILTERS: {
      let emailDateFilter = state.emailDateFilter
      let logDateFilter = state.logDateFilter
      let logDateRange = state.logDateRange
      let emailDateRange = state.emailDateRange

      const updatedFilters = action.payload
      if (
        isFiltersEqual({ ...state.selectedFilters, logDateFilter, emailDateFilter }, updatedFilters)
      ) {
        return state
      }
      Object.keys(updatedFilters).forEach((key) => {
        const value = updatedFilters[key]
        if (key === 'emailDateFilter') {
          if (Array.isArray(value)) {
            emailDateFilter = value
            emailDateRange = value
          } else {
            emailDateFilter = +value
            emailDateRange = getRangeFromDateFilter(emailDateFilter)
          }
          return
        }
        if (key === 'logDateFilter') {
          if (Array.isArray(value)) {
            logDateFilter = value
            logDateRange = value
          } else if (value === null) {
            // Case of "All times". logDateFilter needed for the saved filters
            logDateFilter = null
            logDateRange = null
          } else {
            logDateFilter = +value
            logDateRange = getRangeFromDateFilter(logDateFilter)
          }
          return
        }
        if (!value || value === '' || !value?.length) {
          delete updatedFilters[key]
        } else if (trueOrFalseFilters.has(key) && value.length === 2) {
          updatedFilters[key] = []
        } else {
          updatedFilters[key] = value
        }
      })

      return {
        ...state,
        selectAllStatus: false,
        excludedLogsMap: {},
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
        selectedFilters: updatedFilters,
        emailDateFilter,
        emailDateRange,
        logDateFilter,
        logDateRange,
        page: INITIAL_PAGE,
        loader: true,
        error: null,
      }
    }
    case RESET_ALL_FILTERS: {
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
        selectAllStatus: false,
        excludedLogsMap: {},
        selectedFilters: {},
        logDateFilter: DEFAULT_LOG_DATE_FILTER,
        emailDateFilter: DEFAULT_ARRIVAL_DATE_FILTER,
        logDateRange: getRangeFromDateFilter(DEFAULT_LOG_DATE_FILTER),
        emailDateRange: getRangeFromDateFilter(DEFAULT_ARRIVAL_DATE_FILTER),
        page: INITIAL_PAGE,
        loader: true,
        error: null,
      }
    }
    case PAGINATE_CHANGE: {
      return {
        ...state,
        data: [],
        page: action.payload,
        loader: true,
        error: null,
      }
    }
    case CREATE_INCIDENT.INITIATE: {
      const mutatedData = [...state.data]
      const foundEmailEntity = mutatedData.find(
        (emailEntity) => emailEntity.attrs.new_eid === action.payload.new_eid
      )
      if (foundEmailEntity) {
        foundEmailEntity.attrs.current_incident_id = INCIDENT_BEING_CREATED
      }
      return {
        ...state,
        data: mutatedData,
      }
    }
    case CREATE_INCIDENT.SUCCESS: {
      const updatedData = state.data.map((emailEntity) => {
        if (emailEntity.attrs.eid === action.payload.eid) {
          return {
            ...emailEntity,
            attrs: {
              ...emailEntity.attrs,
              current_incident_id: action.payload.incidentId,
            },
          }
        }
        return emailEntity
      })

      return {
        ...state,
        data: updatedData,
      }
    }
    case CREATE_INCIDENT.ERROR: {
      const mutatedData = [...state.data]
      const error = action.payload.error
      if (!createIncidentErrorCodes.includes(error.status)) {
        return {
          ...state,
          error,
        }
      }
      const foundEmailEntity = mutatedData.find(
        (emailEntity) => emailEntity.attrs.eid === action.payload.email.eid
      )
      switch (error.status) {
        case 403: {
          if (foundEmailEntity) {
            foundEmailEntity.attrs.current_incident_id = null
          }
          if (error.response?.message === allowListErrorMessage) {
            return {
              ...state,
              failedEmail: action.payload.email,
              data: mutatedData,
            }
          }
          return {
            ...state,
            data: mutatedData,
          }
        }
        case 404: {
          if (foundEmailEntity) {
            foundEmailEntity.attrs.current_incident_id = null
          }
          return {
            ...state,
            data: mutatedData,
          }
        }
        case 409: {
          if (foundEmailEntity) {
            foundEmailEntity.attrs.current_incident_id = INCIDENT_BEING_CREATED
          }
          return {
            ...state,
            data: mutatedData,
          }
        }
        default:
          return state
      }
    }
    case CLOSE_ALLOW_LIST_MODAL:
      return {
        ...state,
        failedEmail: null,
      }
    case FETCH_LOGS_ENTIRE_COUNT.INITIATE:
      return {
        ...state,
        logsEntireCount: {
          ...state.logsEntireCount,
          loader: true,
        },
      }
    case FETCH_LOGS_ENTIRE_COUNT.SUCCESS:
      return {
        ...state,
        logsEntireCount: {
          ...state.logsEntireCount,
          value: action.payload.response.count,
          loader: false,
        },
      }
    case FETCH_LOGS_ENTIRE_COUNT.ERROR:
      return {
        ...state,
        logsEntireCount: {
          value: 0,
          loader: false,
          error: action.payload.error,
        },
      }
    case FETCH_LOGS_ENTIRE_COUNT.CANCEL:
      return {
        ...state,
        logsEntireCount: {
          ...logsEntireCountDefaultValue,
        },
      }

    case FETCH_MITIGATION_DATA_ASYNC.INITIATE: {
      return {
        ...state,
        mitigation: {
          ...mitigationDataDefaultValue,
          loader: true,
        },
      }
    }
    case FETCH_MITIGATION_DATA_ASYNC.SUCCESS:
      return {
        ...state,
        mitigation: {
          ...state.mitigation,
          data: action.payload.data,
          loader: false,
        },
      }
    case FETCH_MITIGATION_DATA_ASYNC.ERROR:
      if (action.error.status === 400) {
        return {
          ...state,
          mitigation: {
            data: {},
            error: action.error,
            loader: false,
            emailNotFoundErr: true,
          },
        }
      }
      return {
        ...state,
        mitigation: {
          data: {},
          error: action.error,
          loader: false,
          emailNotFoundErr: false,
        },
      }
    case FETCH_MITIGATION_DATA_ASYNC.CANCEL:
      return {
        ...state,
        mitigation: {
          ...mitigationDataDefaultValue,
        },
      }
    case FETCH_PRESETS_ASYNC.SUCCESS: {
      const selectedFilter = determineSelectedFilter(
        state,
        action.payload.savedFilters,
        action.payload.defaultFilter,
        action.payload.filterFromUrl
      )
      return {
        ...state,
        savedFilters: action.payload.savedFilters,
        savedFiltersOrder: action.payload.savedFiltersOrder,
        defaultFilter: action.payload.defaultFilter,
        selectedFilter,
        unchangeable: false,
        isPresetsLoading: false,
      }
    }
    case SELECT_SAVED_FILTER:
      return {
        ...state,
        selectedFilter: action.payload.presetId,
        unchangeable: false,
        selectedLogsMap: {},
        selectAllStatus: false,
      }
    case CREATE_PRESET_ASYNC.SUCCESS: {
      return {
        ...state,
        selectedFilter: action.payload.response.response.presetId,
        unchangeable: true,
      }
    }
    case SET_UNCHANGEABLE: {
      return {
        ...state,
        unchangeable: action.payload,
        selectedFilter: null,
      }
    }
    case RELEASE_FROM_MS_QUARANTINE_ASYNC.INITIATE: {
      return {
        ...state,
        fetching: {
          ...state.fetching,
          [getKeyForReleaseFetching(action.payload.messageId)]: true,
        },
      }
    }
    case RELEASE_FROM_MS_QUARANTINE_ASYNC.ERROR: {
      return {
        ...state,
        fetching: {
          ...state.fetching,
          [getKeyForReleaseFetching(action.payload.messageId)]: false,
        },
      }
    }
    case RELEASE_FROM_INVESTIGATION_ASYNC.INITIATE: {
      return {
        ...state,
        data: [],
        loader: true,
      }
    }
    case RELEASE_FROM_INVESTIGATION_ASYNC.SUCCESS: {
      return {
        ...state,
        loader: false,
      }
    }
    case RELEASE_FROM_INVESTIGATION_ASYNC.ERROR: {
      return {
        ...state,
        loader: false,
        error: action.error,
      }
    }
    case SET_LOADER: {
      return {
        ...state,
        loader: action.payload,
      }
    }
    case FETCH_PRESETS_ASYNC.INITIATE:
      return { ...state, isPresetsLoading: true }
    case FETCH_PRESETS_ASYNC.ERROR:
      return { ...state, isPresetsLoading: false }
    case FETCH_DIRECTORY_TAGS.INITIATE:
      return { ...state, tagsLoader: true }
    case FETCH_DIRECTORY_TAGS.SUCCESS:
      return {
        ...state,
        tags: {
          ...state.tags,
          ...action.payload.tags.reduce((acc, tag) => {
            acc[tag.id] = tag
            return acc
          }, {}),
        },
        tagsLoader: false,
        totalPages: action.payload.lastPageNum,
      }
    case FETCH_DIRECTORY_TAGS.ERROR:
      return { ...state, tagsLoader: false }
    case SET_TAGS_PAGE:
      return { ...state, tagsPage: action.payload.page }
    case SET_TAGS_SEARCH:
      return { ...state, tagsSearch: action.payload.search }
    default:
      return state
  }
}
